import * as React from "react";
import { Avatar, Box, Tooltip, Typography } from "@mui/material";
import { useGetList } from "ra-core";
import DashboardCard from "./DashboardCard";
import { OrderStatusEnumIcons } from "src/common/enum";
import { formatDateTime, priceFormat } from "src/common/UtilFunctions";
import { useNavigate } from "react-router";

export default function PendingOrderList(props) {
  const { sx, rest } = props;

  const { data } = useGetList("admin/orders", {
    pagination: { page: 1, perPage: 10 },
    sort: { field: "created_at", order: "DESC" },
    filter: {
      "status.in": "backorder,pending,pending_payment,reserve,na_reserve",
    },
  });

  return (
    <DashboardCard {...rest} sx={sx} title="Pending Orders" subheader="">
      {data?.map((order, index) => {
        return <PendingOrderItem key={index} order={order} />;
      })}
    </DashboardCard>
  );
}

function PendingOrderItem({ order }) {
  const navigate = useNavigate();

  const goToOrder = (id) => {
    navigate(`/admin/orders/${id}/show`);
  };

  return (
    <Box sx={{cursor: "pointer" }} 
      display="flex" alignItems="center" margin="15px" onClick={() => goToOrder(order.id)}>
      <PendingOrderItemAvatar order={order} />
      <PendingOrderItemText order={order} />
      <PendingOrderItemPrice order={order} />
    </Box>
  );
}

function PendingOrderItemAvatar({ order }) {
  return (
    <Tooltip placement="top" title={OrderStatusEnumIcons.find((status) => status.id === order.status).name}>
      <Avatar>
        {OrderStatusEnumIcons.find((status) => status.id === order.status).icon}
      </Avatar>
    </Tooltip>
  );
}

function PendingOrderItemPrice({ order }) {
  return (
    <Typography sx={{ marginLeft: "auto" }}>
      {priceFormat(order.total, order.currency)}
    </Typography>
  );
}

function PendingOrderItemText({ order }) {
  let numberOfItems = order.items.reduce((accumulator, item) => {
    return accumulator + item.quantity;
  }, 0);
  return (
    <Box sx={{ marginLeft: "40px" }}>
      <Typography>{order.increment_id}</Typography>
      <Typography color="text.secondary">
        {`${formatDateTime(order.created_at)} - 
          ${numberOfItems === 0 ? "" : numberOfItems}
          ${
            numberOfItems === 1 ? "item" : numberOfItems === 0 ? "" : "items"
          }
        `}
      </Typography>
    </Box>
  );
}
